import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRadioUnchecked = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: .75,
		y: .75,
		width: 22.5,
		height: 22.5,
		rx: 11.25,
		stroke: "#D9DEEB",
		strokeWidth: 1.5
	})
});
const ForwardRef = forwardRef(SvgRadioUnchecked);
export default ForwardRef;
